import { FC, memo } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { FooterWindmill } from './FooterWindmill'
import { TableContent } from './TableContent'
import { SustainabilityProps } from './types'

export const Sustainability: FC<SustainabilityProps> = memo(
  ({
    seo,
    header,
    footer,
    content: {
      breadcrumb,
      header_image,
      header_image_text,
      heading,
      long_text,
      eco_tick,
      table_contents,
      table_header,
      footer_heading,
      footer_long_text,
      fsc_icon,
      windmill,
      green_box,
      milestone,
      milestone_list,
      table_columns_small_screen,
      button_text,
      link
    }
  }) => (
    <Page seo={seo} header={header} footer={footer}>
      <Featured breadcrumb={breadcrumb} header_image={header_image} header_image_text={header_image_text} />
      <TableContent
        heading={heading}
        long_text={long_text}
        eco_tick={eco_tick}
        table_contents={table_contents}
        table_header={table_header}
        table_columns_small_screen={table_columns_small_screen}
        button_text={button_text}
        link={link}
      />
      <FooterWindmill
        footer_heading={footer_heading}
        footer_long_text={footer_long_text}
        fsc_icon={fsc_icon}
        windmill={windmill}
        green_box={green_box}
        milestone={milestone}
        milestone_list={milestone_list}
      />
    </Page>
  )
)

Sustainability.displayName = 'Sustainability'
